import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Link as MuiLink,
  IconButton,
  Divider,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import {
  Facebook,
  Instagram,
  Twitter,
  Email,
  Phone,
  LocationOn,
} from '@mui/icons-material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'grey.100',
        py: 4,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom fontWeight={600}>
              The Random Store
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              Your one-stop destination for custom-made products. We create 
              unique items tailored just for you.
            </Typography>
            
            {/* Social Media */}
            <Box>
              <IconButton size="small" sx={{ mr: 1 }}>
                <Facebook fontSize="small" />
              </IconButton>
              <IconButton size="small" sx={{ mr: 1 }}>
                <Instagram fontSize="small" />
              </IconButton>
              <IconButton size="small" sx={{ mr: 1 }}>
                <Twitter fontSize="small" />
              </IconButton>
            </Box>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom fontWeight={600}>
              Quick Links
            </Typography>
            <Box display="flex" flexDirection="column" gap={1}>
              <MuiLink component={RouterLink} to="/" color="inherit" underline="hover">
                Home
              </MuiLink>
              <MuiLink component={RouterLink} to="/products" color="inherit" underline="hover">
                Products
              </MuiLink>
              <MuiLink component={RouterLink} to="/about" color="inherit" underline="hover">
                About Us
              </MuiLink>
              <MuiLink component={RouterLink} to="/contact" color="inherit" underline="hover">
                Contact
              </MuiLink>
            </Box>
          </Grid>

          {/* Customer Service */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom fontWeight={600}>
              Customer Service
            </Typography>
            <Box display="flex" flexDirection="column" gap={1}>
              <MuiLink component={RouterLink} to="/faq" color="inherit" underline="hover">
                FAQ
              </MuiLink>
              <MuiLink component={RouterLink} to="/shipping" color="inherit" underline="hover">
                Shipping Info
              </MuiLink>
              <MuiLink component={RouterLink} to="/returns" color="inherit" underline="hover">
                Returns & Exchanges
              </MuiLink>
              <MuiLink component={RouterLink} to="/privacy" color="inherit" underline="hover">
                Privacy Policy
              </MuiLink>
              <MuiLink component={RouterLink} to="/terms" color="inherit" underline="hover">
                Terms of Service
              </MuiLink>
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom fontWeight={600}>
              Contact Us
            </Typography>
            
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <Email fontSize="small" color="action" />
              <Typography variant="body2" color="text.secondary">
                info@therandomstore.com
              </Typography>
            </Box>
                    
            <Box display="flex" alignItems="flex-start" gap={1}>
              <LocationOn fontSize="small" color="action" />
              <Typography variant="body2" color="text.secondary">
                324/3 Keshav Nagar<br />
                Aligarh City, UP 202001
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        {/* Copyright */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} The Random Store. All rights reserved.
          </Typography>
          
          <Box display="flex" gap={2} flexWrap="wrap">
            <MuiLink 
              component={RouterLink}
              to="/privacy" 
              variant="body2" 
              color="text.secondary" 
              underline="hover"
            >
              Privacy Policy
            </MuiLink>
            <MuiLink 
              component={RouterLink}
              to="/terms" 
              variant="body2" 
              color="text.secondary" 
              underline="hover"
            >
              Terms of Service
            </MuiLink>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
